// Import dependencies at the top
import React, { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from './theme/theme';
import AppGlobalStyles from './theme/GlobalStyles';
import { UserProvider } from './context/UserContext';

// Firebase imports (move these to the top as well)
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";



// Add Google Fonts
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

// Font Awesome (LOCAL — NO CDN)
import "@fortawesome/fontawesome-free/css/all.min.css";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBYRoEWb1Xet4eBZbsI1C5RgweKi9YM2AE",
  authDomain: "myapp-a4c10.firebaseapp.com",
  projectId: "myapp-a4c10",
  storageBucket: "myapp-a4c10.appspot.com",
  messagingSenderId: "17631405046",
  appId: "1:17631405046:web:6b361237a562a690ebddd7",
  measurementId: "G-9F2SJRGPSG"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Firebase custom hook for messaging
const useFirebase = () => {
  const [firebase, setFirebase] = useState(null);

  useEffect(() => {
    const initializeFirebaseMessaging = async () => {
      if (await isSupported()) {
        const messaging = getMessaging(app);
        setFirebase({ messaging, getToken, onMessage });
      }
    };

    initializeFirebaseMessaging();
  }, []);

  return firebase;
};

// FirebaseApp component to handle notifications
const FirebaseApp = () => {
  const firebase = useFirebase();

  useEffect(() => {
    if (firebase) {
      const { messaging, getToken, onMessage } = firebase;

      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY }).then((currentToken) => {
            if (currentToken) {
              // Send token to your server here
            }
          }).catch(console.error);

          onMessage(messaging, (payload) => {
            new Notification(payload.notification.title, { body: payload.notification.body });
          });
        }
      });
    }
  }, [firebase]);

  return null;
};

// Render React app
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback="Loading...">
          {/* injectFirst makes MUI/Emotion styles inject before our CSS files so
              our layout CSS reliably wins the cascade — fixes elements (e.g. the
              search bar) rendering misplaced on SPA navigation until a refresh. */}
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <AppGlobalStyles />
              <UserProvider>
                <App />
                <FirebaseApp />
              </UserProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </Suspense>
      </I18nextProvider>
    </BrowserRouter>
    <ToastContainer position="top-center" autoClose={3000} limit={3} />
  </React.StrictMode>,
  document.getElementById('root')
);
